import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BottomTabsTitle } from "../../../../Constants/Constants";
import { BottomTabsSubTitle } from "../../../../Data/UiKits/Tabs";
import BottomTabsNav from "./BottomTabsNav";
import BottomTabsNavContent from "./BottomTabsNavContent";

const BottomTabs = () => {
  const [basicTab, setBasicTab] = useState("2");

  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={BottomTabsTitle} span={BottomTabsSubTitle} />
        <CardBody className="bg-navbar bottom-navbar">
          <BottomTabsNavContent tabId={basicTab} />
          <BottomTabsNav basicTab={basicTab} setBasicTab={setBasicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BottomTabs;
